
import { ENDPOINTS } from '../../../../api/endpoints';
import { ENV } from '../../../../config/env';

import {
  LoginRequest,
  LoginResponse,
} from '../../types/Login/auth.types';

export const login = async (
  request: LoginRequest
): Promise<LoginResponse> => {
  const response = await fetch(
    `${ENV.API_BASE_URL}${ENDPOINTS.LOGIN}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    }
  );

  if (!response.ok) {
    throw new Error(
      'Invalid Employee Code or Password'
    );
  }

  return response.json();
};

export const encryptEmployeeCode = async (
  employeeCode: string
): Promise<string> => {
  const response = await fetch(
    `${ENV.API_BASE_URL}${ENDPOINTS.ENCRYPT_EMPLOYEE_CODE}/${encodeURIComponent(
      employeeCode
    )}`
  );

  if (!response.ok) {
    throw new Error(
      'Failed to encrypt employee code'
    );
  }

  return response.json();
};

export const loginSSO = async (
  encryptedId: string
): Promise<LoginResponse> => {
  const url = new URL(
    `${ENV.API_BASE_URL}${ENDPOINTS.LOGIN_SSO}`
  );

  // Pass encrypted employee ID as a query parameter,
  // not as a URL path segment.
  url.searchParams.set('eId', encryptedId);

  const response = await fetch(url.toString(), {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(
      `SSO Login Failed (${response.status})`
    );
  }

  return response.json();
};
